import script from "./Barratt.vue?vue&type=script&setup=true&lang=js"
export * from "./Barratt.vue?vue&type=script&setup=true&lang=js"

import "./Barratt.vue?vue&type=style&index=0&id=a95c20be&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a95c20be"]])

export default __exports__